import { NewBadge } from '../primitives';

/**
 * SectionTitle — заголовок секции на Home.
 * Figma: section-title frames («🔥 Тренды в фото», «Наборы», etc.).
 * Typography Raleway Bold 16/18.78, color text/primary = #FFFFFF α=1.0.
 *
 * Strict-audit §4 closure: text-text-soft (α=0.9) → text-white (α=1.0)
 * — Figma fill is text/primary at full alpha, not soft.
 *
 * NewBadge source: primitive from components/primitives (Figma
 * slider/tag 70:3047 — orange gradient + notched corner + backdrop-blur).
 * Emoji-префикс — часть characters (handoff §19 — админ вводит в title).
 *
 * Props:
 *   title  — string (может содержать emoji)
 *   isNew? — boolean; если true, рендерит NewBadge рядом
 */
export default function SectionTitle({ title, isNew = false }) {
  return (
    <div className="flex items-center gap-2">
      <h2
        className={[
          'font-sans font-bold',
          'text-h2',
          'text-white',
        ].join(' ')}
      >
        {title}
      </h2>
      {isNew && <NewBadge />}
    </div>
  );
}
